import { post, get } from '@/utils/request'

/**
 * @description   获取用户列表
 * @param {*} params
 */
export async function getListUser (params) {
  return get('/rest/getUserList', params)
}
/**
 * @description   添加用户列表
 * @param {*} params
 */
export async function saveUser (params) {
  return get('/rest/register', params)
}
/**
 * @description   获取用户信息
 * @param {*} params
 */
export async function getInfo (params) {
  return get('/rest/getUserInfo', params)
}
/**
 * @description   修改用户信息
 * @param {*} params
 */
export async function updateUser (params) {
  return post('/rest/register', params)
}
/**
 * @description   删除账号
 * @param {*} params
 */
export async function deleteUser (params) {
  return get('/rest/deleteUser', params)
}
/**
 * @description  给用户添加所负责的区域
 * @param {*} params
 */
export async function SaveOrEdit (params) {
  return post('/rest/saveOrEdit', params)
}
/**
 * @description  所有区域字典
 * @param {*} params
 */
export async function getAllRegion () {
  return get('/rest/getAllRegion')
}
/**
 * @description  重置密码
 * @param {*} params
 */
export async function userReset (params) {
  return post('/rest/resetPassword', params)
}
